import { useState, useEffect, useCallback } from "react";
import ProductService from "../../../rest/productService";
import { useRealTimeList } from "../../../ws/useRealtimeList";

export function useProductData(filters, page, pageSize, sort, user) {
    const [pagedData, setPagedData] = useState([]);
    const [totalElements, setTotalElements] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const [loading, setLoading] = useState(false);

    useRealTimeList({
        clientCode: user?.client_code || user?.clientCode || sessionStorage.getItem("clientCode"),
        clientType: 'products',
        setPagedData: setPagedData,
        setTotalElements: setTotalElements
    });

    const fetchData = useCallback(async () => {
        setLoading(true);
        try {
            const apiFilters = {};

            if (filters.categories?.length > 0) {
                apiFilters.categories = filters.categories.map(c => c.value || c);
            }

            if (filters.status?.length === 1) {
                const val = filters.status[0]?.value ?? filters.status[0];
                if (val !== null && val !== undefined) apiFilters.active = val;
            }

            if (filters.minPrice) apiFilters.minPrice = filters.minPrice;
            if (filters.maxPrice) apiFilters.maxPrice = filters.maxPrice;

            const queryParams = {
                search: filters.search || '',
                ...apiFilters,

                page,
                size: pageSize,
                sort
            };

            const response = await ProductService.getAllProducts(queryParams);

            if (response) {
                setPagedData(response.content || []);
                setTotalPages(response.totalPages || 0);
                setTotalElements(response.totalElements || 0);
            }
        } catch (error) {
            console.error("Erro ao carregar produtos:", error);
        } finally {
            setLoading(false);
        }
    }, [filters, page, pageSize, sort]);

    useEffect(() => {
        const timeout = setTimeout(fetchData, 300);
        return () => clearTimeout(timeout);
    }, [fetchData]);

    return {
        pagedData,
        totalElements,
        totalPages,
        loading,
        reloadData: fetchData
    };
}